export const engagementApiSegmentCohortsPreviewSql = "/engagement/api/segment_cohorts/preview_sql";
export const engagementApiSegmentCohortsPreviewSqlQueryId = "/engagement/api/segment_cohorts/preview_sql/:query_id";
